import styled from 'styled-components'

import { FieldWrapper as DefaultFieldWrapper } from '../Shared'

export const FieldWrapper = styled(DefaultFieldWrapper)`
	margin-bottom: 8px;
`
